import { Link } from "react-router-dom";
import { services } from "@/mocks/services";

export default function Leistungen() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Page Header */}
      <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-4 md:mb-6">
              <Link to="/" className="hover:text-primary-600 transition-colors">Startseite</Link>
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line" /></span>
              <span className="text-foreground-700">Leistungen</span>
            </nav>
            <h1 className="font-heading font-bold text-foreground-900 text-3xl md:text-4xl lg:text-5xl mb-3 md:mb-4">
              Unsere Leistungen
            </h1>
            <p className="text-foreground-600 max-w-2xl text-sm md:text-base">
              Von der klassischen Galvanik bis zur spezialisierten Oberflächenveredelung – wir bieten das gesamte Spektrum der Metallbeschichtung.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-10 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-primary-50 rounded-md mb-3 md:mb-4">
                  <span className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center text-primary-500 text-lg md:text-xl">
                    <i className={service.icon} />
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 text-base md:text-lg mb-2 md:mb-3">
                  {service.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-3 md:mb-4">
                  {service.description}
                </p>
                <ul className="space-y-1.5">
                  {service.details.map((detail) => (
                    <li key={detail} className="flex items-start gap-2 text-xs md:text-sm text-foreground-700">
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5 text-primary-500">
                        <i className="ri-check-line" />
                      </span>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="font-heading font-bold text-foreground-900 text-xl md:text-2xl lg:text-3xl mb-8 md:mb-12 text-center">
              Unser Prozess
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {[
                { step: "01", title: "Anfrage", desc: "Sie senden uns Ihre Anfrage mit Zeichnung und Spezifikationen." },
                { step: "02", title: "Analyse", desc: "Wir analysieren Ihre Anforderungen und empfehlen den optimalen Beschichtungsprozess." },
                { step: "03", title: "Produktion", desc: "Die beschichtung wird nach höchsten Qualitätsstandards durchgeführt." },
                { step: "04", title: "Auslieferung", desc: "Die fertigen Teile werden verpackt und termingerecht an Sie geliefert." },
              ].map((item) => (
                <div key={item.step} className="relative">
                  <div className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 h-full">
                    <span className="font-heading font-bold text-3xl md:text-4xl text-primary-200 block mb-2 md:mb-3">
                      {item.step}
                    </span>
                    <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2">
                      {item.title}
                    </h3>
                    <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-10 md:py-16 bg-primary-500">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-heading font-bold text-background-50 text-xl md:text-2xl lg:text-3xl mb-3 md:mb-4">
              Haben Sie ein konkretes Projekt?
            </h2>
            <p className="text-background-100/80 mb-6 md:mb-8 max-w-2xl mx-auto text-sm md:text-base">
              Fordern Sie ein unverbindliches Angebot an. Wir beraten Sie gerne zur optimalen Beschichtungslösung für Ihre Bauteile.
            </p>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-3.5 bg-background-50 text-primary-700 font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap text-sm md:text-base"
            >
              Angebot anfordern
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}